import Vue from "vue";
import App from "./App.vue";
import router from "./router/vue-router";
import VueClipboard from "vue-clipboard2";
import "vue-datetime/dist/vue-datetime.css";
import "es6-promise/auto";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import {
//   faChevronLeft,
//   faChevronRight,
//   faArrowRight,
//   faCircle
// } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// library.add(faChevronLeft, faChevronRight, faArrowRight, faCircle);
// Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueClipboard);

new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js